export default __webpack_public_path__ + "static/media/Roboto-Light.368aee5f.ttf";